module.exports = __webpack_public_path__ + "static/media/WTP_2019.97fa8fb3.jpg";